export var ADDON_ID = 'storybook/outline';
export var PARAM_KEY = 'outline';